import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { Subject, takeUntil } from 'rxjs';
import { NavigationItem } from 'app/core/navigation/navigation.types';
import { HorizontalNavComponent } from './horizontal-nav.component';

@Component({
    selector: 'app-horizontal-nav-branch-item',
    templateUrl: './horizontal-nav-branch-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HorizontalNavBranchItemComponent implements OnInit, OnDestroy {
    @Input() child = false;
    @Input() item!: NavigationItem;
    @Input() name!: string;
    @ViewChild('matMenu', { static: true }) matMenu!: MatMenu;

    private _parent?: HorizontalNavComponent;
    private _unsubscribeAll = new Subject<void>();

    constructor(private _cdr: ChangeDetectorRef, private _parentNav: HorizontalNavComponent) {
        this._parent = _parentNav;
    }

    ngOnInit(): void {
        this._parent?.onRefreshed.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => this._cdr.markForCheck());
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    triggerChangeDetection(): void {
        this._cdr.markForCheck();
    }

    trackByFn(index: number, item: NavigationItem): string | number {
        return item.id ?? index;
    }
}
